import React from 'react'
import { Link } from 'react-router-dom'
import { CATEGORIES } from './registry'
import type { CategorySlug } from './types'

interface CategoryFilterProps {
  activeSlug?: CategorySlug
}

export function CategoryFilter({ activeSlug }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <Link
        to="/motion-playground"
        className={`px-3 py-1.5 text-xs font-medium rounded-full transition-all ${
          !activeSlug
            ? 'bg-gray-900 text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        All
      </Link>
      {CATEGORIES.map((cat) => (
        <Link
          key={cat.slug}
          to={`/motion-playground/examples/${cat.slug}`}
          className={`px-3 py-1.5 text-xs font-medium rounded-full transition-all ${
            activeSlug === cat.slug
              ? `${cat.color} text-white`
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          {cat.label}
        </Link>
      ))}
    </div>
  )
}
